import styled from 'styled-components'

export const PageTitle = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 8px;
  margin-top: ${(props) => {
    return props.marginTop
  }}
`
export const PageSubtitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: row;
  margin-bottom: ${(props) => {
    return props.marginBottom
  }}
`
export const PageSubtitle = styled.div`
  font-size: ${(props) => {
    return props.fontSizePageSubtitle
  }};
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0; 
  border-bottom: 2px dotted rgba(32, 32, 32, 0.5);
  color: rgba(32,32,32,0.7);   
`
export const TooltipHintWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
`
